/*
 * @Author: chenchaoqiang@leedarson.com
 * @Date: 2022-08-03 16:34:18
 * Copyright 2022 Leedarson, All Rights Reserved.
 */
class NativeSystem {
  constructor({ native }) {
    this.native = native;
  }
  /**
   * 震感反馈
   */
  impactFeedback() {
    return this.native.send({
      key: 'System.impactFeedback',
    });
  }

  /**
   * 获取安全区域上下间距
   */
  getSafeAreaInsets() {
    return this.native.send({
      key: 'System.getSafeAreaInsets',
    });
  }

  /**
   * 复制到剪切板
   */
  copy(content) {
    return this.native.send({
      key: 'System.copyToPasteboard',
      content,
    });
  }

  /**
   * 打开浏览器链接
   * @param {String} url - 跳转链接
   */
  openBrowser(url) {
    return this.native.send({
      key: 'System.openBrowser',
      url,
    });
  }

  /**
   * 跳转到指定的 App
   * @param {string} schemeUrl - App Scheme Url
   * @param {string} marketUrl - App 应用市场 Url
   * @param {string} packName - App 包名
   * @param {string} params - App 参数
   */
  openThirdApp(vs) {
    return this.native.send({
      key: 'System.openThirdApp',
      ...vs,
    });
  }

  /**
   * 开启激活(唤醒)状态监听（前后台切换）
   * @param {Function} callback - function({status}) 监听的回调函数，必传
   * @param {Number} status - 状态值
   * 0 DidBecomeActive: - app已经切换到active状态后需要执行的操作
   * 1 WillResignActive: - app将要从前台切换到后台时需要执行的操作
   * 2 DidEnterBackground: - app已经进入后台后需要执行的操作
   * 3 WillEnterForeground: - app将要从后台切换到前台需要执行的操作，但app还不是active状态
   * 4 WillTerminate: - app将要结束时需要执行的操作
   */
  onActiveChange(callback) {
    this.native.on('System.onActiveChange', callback);
  }

  /**
   * 取消激活(唤醒)状态监听（前后台切换）
   * @param {Function} callback - 取消监听的回调函数，可选
   */
  offActiveChange(callback) {
    this.native.off('System.onActiveChange', callback);
  }
}

export default NativeSystem;
